module.exports = __webpack_public_path__ + "img/wheelchair.5acf8181.png";